import { styled } from 'styled-components';

export const IconWrapper = styled.div`
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const OutlineIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${IconWrapper}:hover & {
    display: none;
  }
`;

export const FilledIcon = styled.div`
  display: none;
  justify-content: center;
  align-items: center;

  ${IconWrapper}:hover & {
    display: flex;
  }
`;
